import { Component, OnInit, TemplateRef, ViewChild, Input, Injectable } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { ModalTemplateComponent } from './modal-template/modal-template.component';

@Component({
  selector: 'ngx-modale',
  templateUrl: './modale.component.html',
  styleUrls: ['./modale.component.scss']
})

export class ModaleComponent implements OnInit {

  @Input() titolo: any;
  @Input() messaggio: any;

  constructor(private dialogService: NbDialogService) { }

  ngOnInit() {
  }

  public openModal(titolo: any, messaggio: any): void {

    var ref = this;

    this.dialogService.open(
      ModalTemplateComponent,
      { 
        context: {
          title: titolo,
          messaggio
        }
      }
    );

  }

}
